import axios from "../../axios.js";

const state = {
    siteTitle: '',
    siteEmail: '',
    sitePhone: '',
    siteAddress: '',
    siteAdditionalPhone: '',
    socialMedia: {}
}
const actions = {
    getConfigData:({commit}) => {
        return new Promise((resolve, reject)=>{
            axios.get('/settings/')
            .then(res=>{
                if(res.status === 200){
                    commit('setConfigData', res.data);
                    resolve(res.data);
                }
                // else                
                //     commit('pageError', err);
            })
            .catch(err => {
                //commit('pageError', err);
                reject(err);
            });
        })
    },
    getSocialMedia: ({commit}) => {
        return new Promise((resolve, reject)=>{
            axios.get('/social-media/')
            .then(res=>{
                if(res.status === 200){
                    commit('setSocialMediaData', res.data);
                    resolve(res.data);
                }
            })
            .catch(err => {
                reject(err);
            });
        })
    }
}
const getters = {
    pageTitle: state => state.title
};

const mutations = {
    setConfigData: (state, res) => {
        state.siteTitle = res.title;
        state.siteEmail = res.email;
        state.sitePhone = res.phone;
        state.siteAdditionalPhone = res.additional_no;
        state.siteAddress = res.address;
    },
    setSocialMediaData: (state, res) => {
        state.socialMedia = res.data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
};